interface BotAvatarProps {
    logoSrc?: any;
    hasError?: any;
}

export function BotAvatar({ logoSrc, hasError }: BotAvatarProps) {
    return (
        <div className="w-8 h-8 flex items-center justify-center">
            {logoSrc && !hasError ? (
                <img src={logoSrc} alt="Bot avatar" className="w-8 h-8 object-cover rounded-full" />
            ) : (
                <img src="/favicon.ico" alt="Bot avatar" className="w-8 h-8 object-cover rounded-full" />
            )}
        </div>
    );
}
